import {
  Card,
  CircularProgress,
  FormControlLabel,
  Grid2,
  Switch,
  Typography,
} from "components";
import { useState } from "react";

interface Props {
  data: any;
  isLoading: boolean;
}

const CardsCollection = ({ data, isLoading }: Props) => {
  const [enabled, setEnabled] = useState(false);

  const dataToDisplay = [
    {
      name: "0 ~ 10 lakhs",
      invested: data?.[1]?.invested,
      current: data?.[1]?.current,
    },
    {
      name: "10 ~ 25 lakhs",
      invested: data?.[2]?.invested,
      current: data?.[2]?.current,
    },
    {
      name: "25 ~ 50 lakhs",
      invested: data?.[3]?.invested,
      current: data?.[3]?.current,
    },
    {
      name: "50 lakhs ~ 1 crore",
      invested: data?.[4]?.invested,
      current: data?.[4]?.current,
    },
    {
      name: "1 crore ~ 1.5 crore",
      invested: data?.[5]?.invested,
      current: data?.[5]?.current,
    },
    {
      name: "1.5 crore & Above",
      invested: data?.[6]?.invested,
      current: data?.[6]?.current,
    },
  ];

  return (
    <Card
      style={{
        position: "relative",
      }}
    >
      <div
        style={{
          background: `var(--primary-900)`,
          opacity: 0.1,
          height: 120,
          width: 120,
          borderRadius: "100%",
          position: "absolute",
          bottom: -40,
          left: -40,
          zIndex: 0,
        }}
      >
        {" "}
      </div>
      <div
        style={{
          background: `var(--primary-900)`,
          height: 130,
          width: 130,
          borderRadius: "100%",
          position: "absolute",
          top: -45,
          right: -45,
          zIndex: 0,
          opacity: 0.1,
        }}
      >
        {" "}
      </div>

      <Grid2 container spacing={1}>
        <Grid2
          size={12}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            fontSize={16}
            color={"var(--primary-900)"}
            fontWeight={700}
          >
            Portfolio Ticket Wise
          </Typography>
          <FormControlLabel
            value="end"
            control={
              <Switch
                onChange={(event) => {
                  setEnabled(event.target.checked);
                }}
              />
            }
            label={enabled ? "Invested" : "Current"}
            labelPlacement="end"
          />
        </Grid2>
        <Grid2 container>
          {dataToDisplay?.map((card, index) => (
            <Grid2 container size={12} key={index} spacing={0}>
              <Grid2
                size={8}
                p={2}
                style={{
                  border: `solid 1px var(--primary-900)`,
                  borderRadius: "10px 0 0 10px",
                  borderRight: "none",
                }}
              >
                <Typography
                  width={"100%"}
                  fontSize={16}
                  fontWeight={700}
                  textAlign={"center"}
                  color={"var(--primary-900)"}
                >
                  {card?.name || "-"}
                </Typography>
              </Grid2>
              <Grid2
                size={4}
                p={2}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                style={{
                  border: `solid 1px var(--primary-900)`,
                  borderRadius: "0 10px 10px 0",
                }}
              >
                {isLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Typography
                    fontSize={16}
                    width={"100%"}
                    fontWeight={700}
                    textAlign={"center"}
                    color={"var(--primary-900)"}
                  >
                    {enabled && !isLoading ? card?.invested : card?.current}
                  </Typography>
                )}
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default CardsCollection;
